






import Vue from 'vue'
import * as firebase from 'firebase/app'
import 'firebase/auth'

export default Vue.extend({
  name: 'Logout',
  methods: {
    signOut () {
      if (firebase.auth().currentUser) {
        firebase.auth().signOut()
      }
    }
  }
})

